import React from 'react';
import useScrollReveal from '../../hooks/useScrollReveal';

const ScrollReveal = ({
  children,
  className = '',
  delay = 0,
  as: Tag = 'div',
  ...options
}) => {
  const { ref, isVisible } = useScrollReveal(options);
  const Component = Tag === 'motion.div' ? 'div' : Tag;

  return (
    <Component
      ref={ref}
      className={`reveal ${isVisible ? 'reveal--visible' : ''} ${className}`.trim()}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Component>
  );
};

export default ScrollReveal;
